import React, { useState } from 'react';
import { Input } from '../common/Input';
import { Button } from '../common/Button';
import { CreateQuestionData } from '../../services/questionService';

type AddQuestionFormProps = {
  onAddQuestion: (questionData: CreateQuestionData) => Promise<void>;
};

export const AddQuestionForm = ({ onAddQuestion }: AddQuestionFormProps) => {
  const [text, setText] = useState('');
  const [optionA, setOptionA] = useState('');
  const [optionB, setOptionB] = useState('');
  const [optionC, setOptionC] = useState('');
  const [correctOptions, setCorrectOptions] = useState<Array<'A' | 'B' | 'C'>>([]);
  const [imageFile, setImageFile] = useState<File | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleCorrectOptionChange = (option: 'A' | 'B' | 'C') => {
    setCorrectOptions(prev => 
      prev.includes(option)
        ? prev.filter(item => item !== option) // Odznacz
        : [...prev, option] // Zaznacz
    );
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files[0]) {
      setImageFile(event.target.files[0]);
    }
  };

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    if (correctOptions.length === 0) {
      alert('Musisz zaznaczyć co najmniej jedną poprawną odpowiedź.');
      return;
    }
    setIsLoading(true);

    await onAddQuestion({ text, optionA, optionB, optionC, correct_options: correctOptions, imageFile });

    // Resetowanie formularza
    setText('');
    setOptionA('');
    setOptionB('');
    setOptionC('');
    setCorrectOptions([]);
    setImageFile(null);
    // Jeśli masz referencję do inputa pliku, możesz ją wyczyścić
    // np. fileInputRef.current.value = null;
    setIsLoading(false);
  };

  return (
    <form onSubmit={handleSubmit}>
      <h3>Dodaj nowe pytanie</h3>
      <Input id="question-text" label="Treść pytania" value={text} onChange={(e) => setText(e.target.value)} required />
      <Input id="option-a" label="Odpowiedź A" value={optionA} onChange={(e) => setOptionA(e.target.value)} required />
      <Input id="option-b" label="Odpowiedź B" value={optionB} onChange={(e) => setOptionB(e.target.value)} required />
      <Input id="option-c" label="Odpowiedź C" value={optionC} onChange={(e) => setOptionC(e.target.value)} required />
      
      <div style={{ marginBottom: '1rem' }}>
        <label>Obrazek do pytania (opcjonalnie):</label>
        <input type="file" accept="image/*" onChange={handleFileChange} />
      </div>

      <div style={{ marginBottom: '1rem' }}>
        <label style={{ fontWeight: 'bold' }}>Poprawne odpowiedzi:</label>
        <div>
          {['A', 'B', 'C'].map((opt) => (
            <label key={opt} style={{ marginRight: '1rem' }}>
              <input
                type="checkbox" // ZMIANA: z radio na checkbox
                checked={correctOptions.includes(opt as 'A' | 'B' | 'C')}
                onChange={() => handleCorrectOptionChange(opt as 'A' | 'B' | 'C')}
              /> {opt}
            </label>
          ))}
        </div>
      </div>
      <Button type="submit" disabled={isLoading}>
        {isLoading ? 'Dodawanie...' : 'Dodaj pytanie'}
      </Button>
    </form>
  );
};